<style src="vue-select/dist/vue-select.css"></style>
<style>
    .table-sm {
        font-size: 12px;
    }
</style>

<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Daftar Kode Bantu</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
									<i class="fa fa-plus-square"></i>
									Tambah
								</button>
                            </div>
                        </div>
                        <div class="card-body table-responsive p-2">
                            <table class="table table-hover table-sm">
                                <colgroup>
                                    <col style="width: 10%;">
                                    <col style="width: 45%;">
                                    <col style="width: 20%;">
                                    <col style="width: 10%;">
                                </colgroup>
								<thead style="color: black;">
                                    <tr>
                                        <th>KODE AKUN</th>
                                        <th>NAMA AKUN</th>
                                        <th>POST SALDO</th>
                                        <th>AKSI</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(parent, index) in parents.data">
                                        <tr>
                                            <td style="background-color:#e8e8e8 " colspan="4"><strong>{{ parent.nama_akun }}</strong></td>
                                        </tr>
                                        <template v-if="parent.children && parent.children.length">
                                            <tr v-for="(child, childIndex) in parent.children" :key="`child-${index}-${childIndex}`">
                                                <td>&nbsp;&nbsp;&nbsp;&nbsp; {{ child.id }}</td>
                                                <td>&nbsp;&nbsp;&nbsp;&nbsp; {{ child.nama_akun }}</td>
                                                <td>{{ formattedPostSaldo(child.post_saldo) }}</td>
                                                <td class="text-nowrap"> <!-- Agar tombol tetap dalam satu baris -->
                                                    <button @click="editModal(child)" class="btn btn-xs btn-primary">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                    <button @click="deleteData(child.id)" class="btn btn-xs btn-danger">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </table>
						</div>
                        <div class="card-footer">
                            <pagination 
                                :data="parents" 
                                @pagination-change-page="getResults">
                            </pagination>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal -->
			<div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" v-show="!editmode">Tambah Kode Akun</h5>
							<h5 class="modal-title" v-show="editmode">Edit Kode Akun</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<form @submit.prevent="editmode ? updateData() : createData()">
							<div class="modal-body">
								<div class="form-group">
									<label>Nama Akun</label>
									<input v-model="form.nama_akun" type="text" name="nama_akun" class="form-control"
										:class="{ 'is-invalid': form.errors.has('nama_akun') }" required>
									<has-error :form="form" field="nama_akun"></has-error>
								</div>
								<div class="form-group">
									<label>Post Saldo</label>
									<select v-model="form.post_saldo" type="text" name="post_saldo" class="form-control"
										:class="{ 'is-invalid': form.errors.has('post_saldo') }" required>
										<option selected disabled value="">Pilih...</option>
										<option v-bind:value="1">Debet</option>
										<option v-bind:value="2">Credit</option>
									</select>
									<has-error :form="form" field="post_saldo"></has-error>
								</div>
								<div class="form-group">
									<label>Header</label>
									<select class="form-control" v-model.lazy="form.id_parent">
										<option selected disabled value="">Pilih...</option>
										<option 
											v-for="(value) in id_parent" :key="value.id"
											:value="value.id">{{ value.nama_akun }}
										</option>
									</select>
									<small  v-if="adaeror['id_parent']" class="text-danger">
										{{adaeror["id_parent"].join(', ') }}
									</small> 
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
								<button v-show="editmode" type="submit" class="btn btn-success">Edit!</button>
								<button v-show="!editmode" type="submit" class="btn btn-primary">Tambah!</button>
							</div>
						</form>
					</div>
				</div>
			</div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                editmode: false,
                parents: {},
                id_parent: [],
                adaeror: [],
                form: new Form({
                    id: '',
                    nama_akun: '',
                    post_saldo: '',
                    post_laporan: '',
                    id_parent: '',
                })
            };
        },

        computed: {
            formattedPostSaldo() {
                return (value) => {
                    if (value === 1) return 'Debet';
                    if (value === 2) return 'Credit';
                    return '-';
                };
            }
        },

        methods: {
            async getResults(page = 1) {
                this.$Progress.start();
                try {
                    const { data } = await axios.get(`api/bantu?page=${page}`);
                    this.parents = data.parents;
                    this.$Progress.finish();
                } catch (error) {
                    console.error("Error fetching data:", error);
                    this.$Progress.fail();
                }
            },
            
            async loadHeader() {
                try {
                    const { data } = await axios.get("api/bantu/header");
                    this.id_parent = data.data;
                } catch (error) {
                    console.error("Error loading header:", error);
                }
            },
      
            editModal(rowEdit) {
                this.editmode = true;
                this.form.reset();
                this.form.fill(rowEdit);

                $('#addNew').modal('show');
            },

            newModal() {
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            async createData() {
                try {
                    this.$Progress.start();

                    const response = await this.form.post('api/bantu');

                    if (response.data.success) {
                        $('#addNew').modal('hide');
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });

                        this.$Progress.finish();
                        this.getResults(); 
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occurred! Please try again'
                        });

                        this.$Progress.fail();
                    }
                } catch (error) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response?.data?.message || 'Terjadi kesalahan, silakan coba lagi'
                    });

                    this.$Progress.fail();
                }
            },

            async updateData() {
                this.$Progress.start();
                try {
                    const response = await this.form.put(`api/bantu/${this.form.id}`);

                    // Sembunyikan modal secara Vue-friendly (gunakan ref jika memungkinkan)
                    $('#addNew').modal('hide');

                    // Tampilkan notifikasi sukses
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });

                    this.$Progress.finish();

                    // Refresh data setelah update
                    this.getResults();
                } catch (error) {
                    this.$Progress.fail();
                    Toast.fire({
                        icon: 'error',
                        title: 'Terjadi kesalahan saat update data.'
                    });
                }
            },

            async deleteData(id) {
                try {
                    const result = await Swal.fire({
                        title: 'Hapus?',
                        text: "Yakin untuk Menghapus Kode Akun?",
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Ya, Hapus!'
                    });

                    // Jika user menekan tombol "Ya, Hapus!"
                    if (result.isConfirmed) {
                        await this.form.delete(`api/bantu/${id}`);

                        Swal.fire(
                            'Terhapus!',
                            'Data Kode Akun berhasil dihapus.',
                            'success'
                        );

                        // Refresh data setelah menghapus
                        this.getResults();
                    }
                } catch (error) {
                    Swal.fire("Hapus Gagal!", "Terjadi kesalahan saat menghapus data.", "warning");
                }
            }
        },

        mounted() {
            this.getResults();
            this.loadHeader();
        },

        created() {
            this.$Progress.start();
            this.getResults();
            this.loadHeader();
            this.$Progress.finish();
        }
    }
</script>